module.exports = __webpack_public_path__ + "media/images/gallery/constellations/libra/lib_lines-0b4a1d1144b47593c76089f679455550.gif";